module.exports = __webpack_public_path__ + "static/media/reflix-ilus.f1163b00.jpg";